export default __webpack_public_path__ + "static/media/pourover.0a3f93ef.png";